import type { BlokProps } from "@trydig/storyblok";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import { ExplorationCategory } from "@/components/ui/sections/ExplorationCategory";
import type { ExplorationCategoryStoryblok } from "@/generated/sb/sb-types";
import { sbLink } from "@/lib/storyblok/link";
import { checkBlokBackground } from "@/lib/utils/isDarkMode";

export const ExplorationCategoryBlok = ({
	blok,
	preview,
}: BlokProps<ExplorationCategoryStoryblok>) => {
	const linkHref = sbLink(blok.link)?.href;
	const bg = checkBlokBackground(blok);

	return (
		<BlokWrap editable={blok} asChild>
			<ExplorationCategory
				heading={blok.heading || undefined}
				linkLabel={blok.linkLabel || undefined}
				linkHref={linkHref}
				categories={blok.categories}
				bg={bg}
				preview={preview}
			/>
		</BlokWrap>
	);
};
